// hooks/useHeroScrollProgress.js
import { useEffect, useRef, useState } from "react";
export function useHeroScrollProgress() {
  const ref = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const triggerStart = windowHeight * 0.15; // Cuando empieza la animación
      const triggerEnd = windowHeight * 0.05;   // Cuando termina centrado
      let raw = (rect.top - triggerEnd) / (triggerStart - triggerEnd);
      let clamped = Math.max(0, Math.min(1, 1 - raw));
      setProgress(clamped);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return [ref, progress];
}
